/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        card: {
            gap: {
                value: "8px",
                type: "dimension",
            },
            padding: {
                value: "16px",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "4px",
                            blur: "24px",
                            spread: "-8px",
                            color: "#00000010",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "1px",
                            blur: "6px",
                            spread: "-2px",
                            color: "#00000038",
                        },
                    ],
                    stringValue: "0px 4px 24px -8px #00000010, 0px 1px 6px -2px #00000038",
                },
                type: "shadow",
            },
            focus: {
                boxShadow: {
                    value: {
                        layers: [
                            {
                                inset: false,
                                offsetX: 0,
                                offsetY: 0,
                                blur: 0,
                                spread: "calc(1px + 1px)",
                                color: "#ffffff",
                            },
                            {
                                inset: false,
                                offsetX: 0,
                                offsetY: 0,
                                blur: 0,
                                spread: "calc(2px + 1px + 1px)",
                                color: "#3e95fa",
                            },
                        ],
                        stringValue: "0 0 0 calc(1px + 1px) #ffffff, 0 0 0 calc(2px + 1px + 1px) #3e95fa",
                    },
                    type: "shadow",
                },
            },
            group: {
                border: {
                    value: "1px solid #D5E3F1",
                    type: "dimension",
                },
                outline: {
                    value: "1px solid #D5E3F1",
                    type: "dimension",
                },
            },
            title: {
                fontSize: {
                    value: "1.375rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.625rem",
                    type: "dimension",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                image: {
                    height: {
                        value: "75px",
                        type: "dimension",
                    },
                    width: {
                        value: "75px",
                        type: "dimension",
                    },
                },
            },
            content: {
                gap: {
                    value: "16px",
                    type: "dimension",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
            },
            image: {
                paddingVertical: {
                    value: "8px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
